import { IContact } from 'clickNgo/entities/contact'

type TCompareProps = {
  contact: IContact
}

export function compareProps(prev: TCompareProps, next: TCompareProps) {
  return prev.contact.contactId === next.contact.contactId
}
